export enum StyleTypesApiEnum {
    TEXT = 'TEXT',
    CURATED_MENTION_LIST = 'CURATED_MENTION_LIST',
    AUTOMATIC_MENTION_LIST = 'AUTOMATIC_MENTION_LIST',
    DATE = 'DATE',
    CONTAINER = 'CONTAINER',
    ALERT = 'ALERT',
    SURGE_ALERT = 'SURGE_ALERT',
    TITLE = 'TITLE',
    IMAGE = 'IMAGE',
    MENTION = 'MENTION',
    TABLE_OF_CONTENT = 'TABLE_OF_CONTENT',
    DIVIDER = 'DIVIDER',
    FOOTER = 'FOOTER',
    BUTTON = 'BUTTON',
    VIDEO = 'VIDEO',
    LINKS = 'LINKS',
    CONTACT = 'CONTACT',
    LINK = 'LINK',
    ONE_COLUMN_LAYOUT = 'ONE_COLUMN_LAYOUT',
    TWO_COLUMN_LAYOUT = 'TWO_COLUMN_LAYOUT',
    THREE_COLUMN_LAYOUT = 'THREE_COLUMN_LAYOUT',
    ANALYSIS = 'ANALYSIS',
    CHART = 'CHART',
    COVERAGE_CURATOR = 'COVERAGE_CURATOR',
}

